import { FC } from "react";
import { MainContentWrapper } from "../../layouts/base/MainContentWrapper";
import { MainContentHeader } from "../../layouts/base/MainContentHeader";
import { useTitlePage } from "../../hooks/use-title-page";
import { Stack, Typography } from "@mui/material";
import { ParagraphSection } from "../../components/common/ParagraphSection";

const title = "מדיניות פרטיות";
const PrivacyPage: FC = () => {
  useTitlePage(title);
  return (
    <MainContentWrapper>
      <MainContentHeader title={title} />
      <Stack gap={2}>
        <Typography fontWeight={700} variant="h5" gutterBottom>
          מדיניות פרטיות – אפליקציית "אחד"
        </Typography>

        <ParagraphSection
          title="מדיניות פרטיות"
          paragraphs={[
            `בעל האפליקציה "אחד" (להלן "האפליקציה")  מכבד את פרטיות המשתמשים באפליקציה שהוא מנהל ומפעיל. על כן החליט בעל האפליקציה לפרסם את מדיניותו ביחס להגנת הפרטיות, והוא מתחייב כלפי המשתמש לקיים מדיניות זו.`,
            `מטרת מסמך המדיניות היא להסביר מהם נוהגי בעל האפליקציה ביחס לפרטיות המשתמשים ובין היתר – איזה מידע נאסף אודות המשתמשים? כיצד משתמש בעל האפליקציה במידע, הנמסר לו על-ידי המשתמשים באפליקציה או הנאסף  בעת השימוש בה.`,
            `מדיניות הפרטיות הינה בהתאם לאמור בסעיף 11 לחוק הגנת הפרטיות התשמ"א 1981.`,
            `מדיניות הפרטיות מנוסחת בלשון זכר ומכוונת לשני המינים.`,
            `אנא קרא והבן את הוראות מדיניות הפרטיות.`,
            `אם בחרת להמשיך ולהשתמש בשירותי האפליקציה, יש לראות זאת כהסכמה וקבלת מלוא הוראות מדיניות הפרטיות.`,
            `אם אינך מעוניין כי יאסף עליך מידע כאמור במדיניות הפרטיות, אנא הימנע משימוש באפליקציה.`,
            `יש לציין כי לא חלה על המשתמש כל חובה שבדין למסור את המידע.`,
          ]}
        />
        <ParagraphSection
          title="סוג המידע הנאסף"
          paragraphs={[
            `בעת השימוש בשירותי האפליקציה נאסף מידע אודותיך, חלקו מזהה אותך אישית:`,
            `פרטי יצירת קשר, כגון שמך, כתובת דואר אלקטרוני, כתובת, מספר טלפון.`,
            `מידע שהעברת במסגרת התכתבויות ו/או תקשורת עם האפליקציה`,
            `חלק מהמידע אינו מזהה אישית, למשל:`,
            `פרסומות שקראתם באפליקציה`,
            `הדפים שבהם צפית`,
            `כתובת האינטרנט (IP) ממנה הגשת בקשה ועוד.`,
          ]}
        />
        <ParagraphSection
          title="רישום לשירותים באפליקציה"
          paragraphs={[
            `לצורך שימוש באפליקציה, עליך להירשם לאפליקציה ולמסור מידע כפי שתתבקש.`,
          ]}
        />
        <ParagraphSection
          title="איסוף המידע"
          paragraphs={[
            `הנתונים שיאספו וכן תכנים שהמשתמש מעלה ו/או משתף ו/או יוצר באפליקציה, יישמרו ברשות בעל האפליקציה. מסד הנתונים מאוחסן בשרתי אחסון וכן בשרתים של נותני שירות של האפליקציה. המשתמש באפליקציה מצהיר כי הוא מסכים לשמירת מידע בשרתים אלו, אשר עשויים להיות בארץ או בחו"ל.`,
          ]}
        />
        <ParagraphSection
          title="מטרות איסוף ושימוש במידע"
          paragraphs={[
            `השימוש במידע שנאסף, ייעשה רק בהתאם למדיניות פרטיות זו, או בהתאם להוראות כל דין החל, על מנת –`,
            `לאפשר שימוש בשירותים שונים באפליקציה`,
            `לשפר את השירותים והתכנים המוצעים באפליקציה`,
            `לתקשר איתך ולהשיב לפניותיך`,
            `לשנות או לבטל שירותים ותכנים קיימים`,
            `על מנת להתאים את המודעות שיוצגו בעת ביקורך באפליקציה לתחומי העניין שלך`,
            `לצורך אכיפת כללים ונהלים באפליקציה כפי שהם מופיעים בתנאי השימוש`,
            `למטרות בקרה`,
            `למטרות יצירת קשר מסחרי ו/או שיווקי`,
          ]}
        />
        <ParagraphSection
          title="הבסיס החוקי לאיסוף המידע"
          paragraphs={[
            `אנו נעבד את המידע האישי שלך, לרבות מידע רגיש, רק כאשר יש לנו בסיס חוקי לעשות זאת. הבסיסים המשפטיים לעיבוד עשויים לכלול:`,
            `עיבוד המידע הכרחי לקיום התקשרות איתך או כדי לנקוט בצעדים לפי בקשתך טרם התקשרות בחוזה.`,
            `עיבוד המידע הכרחי כדי לעמוד בהתחייבות משפטית.`,
            `קיבלנו את הסכמתך המפורשת לעיבוד.`,
            `עיבוד המידע הכרחי לביסוס, מימוש או הגנה של תביעות משפטיות.`,
          ]}
        />
        <ParagraphSection
          title="דיוור ישיר אלקטרוני ויצירת קשר עם המשתמש"
          paragraphs={[
            `בעל האפליקציה מעוניין לעדכן את המשתמשים שלנו לגבי עדכונים חשובים, התפתחויות ועניינים רלוונטיים אחרים הקשורים לאפליקציה. על מנת להבטיח תקשורת רציפה ומעודכנת, בעל האפליקציה רשאי לשלוח הודעות (נוטיפיקציות) למשתמשים.`,
            `כמו כן, אנו מעוניינים לשלוח אליך, מעת לעת, ניוזלטרים או הודעות אחרות במייל, ו/או ב-SMS או בוואטסאפ, אודות שירותינו וכן מידע שיווקי ופרסומי.`,
            `מידע כזה יישלח אליך רק, אם נתת הסכמתך המפורשת, ובכל עת תוכל לבטל את הסכמתך ולהפסיק לקבלו.`,
            `לא נמסור את המידע האישי שלך למפרסמים. עם זאת, אנו עשויים להעביר מידע סטטיסטי על פעילות המשתמשים באפליקציה לצדדים שלישיים.`,
          ]}
        />
        <ParagraphSection
          title="מסירת מידע לצד שלישי"
          paragraphs={[
            `בעל האפליקציה לא יעביר לצדדים שלישיים את פרטיך האישיים והמידע שנאסף על פעילותך באפליקציה אלא במקרים המפורטים להלן:`,
            `אם תרכוש מוצרים ושירותים מצדדים שלישיים המציעים אותם למכירה באמצעות האפליקציה, יסופק לצד השלישי המידע הנחוץ לו להשלמת תהליך הרכישה;`,
            `במקרה של מחלוקת משפטית בינך לבין בית העסק שתחייב את חשיפת פרטיך;`,
            `אם תבצע באפליקציה פעולות המנוגדות לחוק;`,
            `אם יתקבל צו בית משפט המורה למסור את פרטיך או המידע אודותיך לצד שלישי;`,
            `העברות בעלות עסקיות, מיזוגים וכיוב': במקרה של מיזוג, רכישה או העברה של נכסים, המידע האישי שלך עשוי להיות מועבר לצד שלישי כחלק מהעסקה, בתנאי שהתאגיד הנעבר יקבל על עצמו את הוראות מדיניות פרטיות זו`,
          ]}
        />
        <ParagraphSection
          title="פרסומות של צדדים שלישיים"
          paragraphs={[
            `בעל האפליקציה מתיר לחברות אחרות לנהל את מערך הפרסומות באפליקציה. המודעות שבהן אתה צופה בעת השימוש מגיעות ממחשביהן של אותן חברות. כדי לנהל את הפרסומות שלהן, חברות אלה מציבות Cookies במחשבך. ה-Cookies מאפשרים להן לאסוף מידע על האתרים שבהם צפית בפרסומות שהציבו ועל אילו פרסומות הקשת. השימוש שחברות אלה עושות ב-Cookies כפוף למדיניות הפרטיות שלהן ולא למדיניות הפרטיות של האפליקציה.`,
          ]}
        />
        <ParagraphSection
          title="אבטחת מידע"
          paragraphs={[
            `באפליקציה מיושמות מערכות ונהלים עדכניים לאבטחת מידע. בעוד שמערכות ונהלים אלה מצמצמים את הסיכונים לחדירה בלתי-מורשית, אין הם מעניקים בטחון מוחלט. לכן, בעל האפליקציה לא מתחייב שהאפליקציה ושירותיו יהיו חסינים באופן מוחלט מפני גישה בלתי-מורשית למידע המאוחסן בהם והמשתמש מצהיר כי הוא מודע ומסכים לכך.`,
          ]}
        />
        <ParagraphSection
          title="זכויות נשוא  המידע"
          paragraphs={[
            `על-פי חוק הגנת הפרטיות, התשמ"א - 1981, כל אדם זכאי לעיין במידע אודותיו, המוחזק במאגר מידע. אדם שעיין במידע שעליו ומצא כי אינו נכון, שלם, ברור או מעודכן, רשאי לפנות לבעל מאגר המידע בבקשה לתקן את המידע או למוחקו.`,
            `פנייה כזאת יש להפנות אל בעל האפליקציה בדואר אלקטרוני : Support@echadapp.com`,
            `בנוסף, אם המידע שבמאגרי בעל האפליקציה משמש לצורך פניה אישית אליך,  אתה זכאי על-פי חוק הגנת הפרטיות, התשמ"א- 1981 לדרוש בכתב שהמידע המתייחס אליך יימחק ממאגר המידע.`,
          ]}
        />
        <ParagraphSection
          title="שינויים במדיניות הפרטיות"
          paragraphs={[
            `אנו נסקור ונעדכן באופן קבוע את מדיניות הפרטיות שלנו כדי להבטיח שהיא משקפת את נוהלי הטיפול הנוכחיים שלנו בנתונים. כל העדכונים יימסרו לך בבירור, ואנו נקבל את הסכמתך ככל ויידרש על פי דין.`,
          ]}
        />
        <ParagraphSection
          title="דיווח על פגיעה בפרטיות"
          paragraphs={[
            `אם אתה סבור כי פרטיותך נפגעה במסגרת או בזיקה לפעילות האפליקציה, אנא פנה לבעל האפליקציה ופרט בפנייתך את נסיבות הפגיעה כפי שאתה רואה אותה.`,
            `כמו כן, אם יש לך שאלות או חששות בנוגע לעיבוד המידע האישי שלך או שתרצה לממש את זכויותיך, אנו נענה תוך זמן סביר לפניותיך ונספק לך את המידע הדרוש לך.`,
            `תוכל ליצור איתנו קשר כאן Support@echadapp.com מדיניות הפרטיות עודכנה בחודש ינואר 2024`,
          ]}
        />
      </Stack>
    </MainContentWrapper>
  );
};

export default PrivacyPage;
